import type { ExternalTableSchema } from '@packages/table-builder';

export const tradePreClearanceApprovalTable: ExternalTableSchema = {
  metadata: {
    title: 'Trade Pre-Clearance Requests',
    entity: 'TradePreClearanceApproval',
  },

  dataSource: {
    endpoint: '/api/award/api/app/trade-pre-clearance-approval/pre-clearance-request-list',
    method: 'GET',
    rowIdField: 'id',
    responseMapping: {
      items: 'items',
      totalCount: 'totalCount',
    },
    requestParams: {
      Filter: 'table.searchText',
      Sorting: 'table.sorting',
      SkipCount: 'table.pageOffset',
      MaxResultCount: 'table.pageSize',
      ApprovalStatusIds: 'filters.approvalStatusId',
      AwardTypeId: 'filters.awardTypeId',
    },
    filters: [
      {
        name: 'approvalStatusId',
        placeholder: 'Status',
        type: 'asyncSelect',
        multiple: true,
        dataSource: {
          url: '/api/award/api/app/trade-pre-clearance-approval/approval-status',
          labelField: 'name',
          valueField: 'id',
        },
      },
      {
        name: 'awardTypeId',
        placeholder: 'Award Type',
        type: 'asyncSelect',
        dataSource: {
          url: '/api/award/api/app/plan-type/plan-types',
          labelField: 'name',
          valueField: 'id',
        },
      },
    ],
  },

  columns: [
    { field: 'requestedDate', header: 'Request Date', type: 'date', sortable: true, width: 200 },
    {
      field: 'participantName',
      header: 'Participant Details',
      type: 'couple',
      sortable: true,
      width: 200,
      couple: {
        titleField: 'participantName',
        subtitleField: 'employeeId',
      },
    },
    { field: 'employeeType', header: 'Employee Type', sortable: true, width: 200 },
    { field: 'awardTypes', header: 'Award Type', sortable: false, width: 200 },
    {
      field: 'transactionQty',
      header: 'Transaction Quantity',
      type: 'number',
      sortable: false,
      width: 200,
      align: 'center',
    },
    {
      field: 'approvalStatus',
      header: 'Status',
      type: 'badge',
      sortable: false,
      width: 150,
      align: 'center',
      badge: {
        statusMap: {
          Approved: 'success',
          Rejected: 'error',
          Pending: 'info',
        },
        defaultVariant: 'info',
      },
    }
],

  actions: {
    row: [
      { id: 'VIEW_TRADE_PRE_CLEARANCE_APPROVAL', label: 'View' },
      { id: 'VIEW_REJECTED_NOTES_TRADE_PRE_CLEARANCE_APPROVAL', label: 'Rejected Notes' },
    ],
  },

  features: {
    search: { enabled: true },
    pagination: { mode: 'infiniteScroll', defaultSize: 50 },
    columnPreferences: { persistenceKey: 'Trade pre-clearance approval', resizable: true, reorderable: true },
  },
};
